import { useEffect, useMemo, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureButton } from '@/ui/svg-icon';
import Markdown from '@/components/markdown';
import { Skeleton } from 'antd';
import { useMcpItemContext } from '../chat-history/context';
import McpError from './components/error';

const CardThinking = observer(props => {
  const { key, event, data } = props;

  const {
    isAITyping,
  } = useMcpItemContext();
  const isEmpty = data.toString().trim() == '';
  const [autoScroll, setAutoScroll] = useState(true);
  const refTextScroll = useRef(null);

  useEffect(() => {
    if (autoScroll) {
      const el = refTextScroll?.current;
      
      el?.scrollTo({
        left: 0,
        top: el.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [data]);

  const mouseenter = () => {
    setAutoScroll(false)
  }

  const mouseleave = () => {
    setAutoScroll(true)
  }
    
  useEffect(() => {
    const el = refTextScroll?.current;
    el?.addEventListener('mouseenter', mouseenter);
    el?.addEventListener('mouseleave', mouseleave);

    return () => {
      el?.removeEventListener('mouseenter', mouseenter);
      el?.removeEventListener('mouseleave', mouseleave);
    }
  }, []);

  return (
    <>
      <div className="flex items-center h-20px px-24px my-16px ">
        <SVGPureButton name="thinking" className="size-16px !text-black" />
        <div className="text-14px font-bold text-black ml-10px">思考过程</div>
      </div>
      <div
        className="card-thinking pl-24px pr-16px mr-4px mb-16px overflow-x-hidden overflow-y-auto scrollbar"
        ref={refTextScroll}
      >
        {
          isAITyping && isEmpty && event?.status == "running" 
          ? (
            <Skeleton className="" active />
          ) 
          : isEmpty
          ? (
            <McpError />
          )
          : (
            <div className="text-black text-opacity-50 text-16px leading-28px relative overflow-x-hidden flex pl-14px flex-grow">
              <div className="h-full absolute left-0 top-0 w-3px mr-11px rounded-2px bg-[#E5E5E5] flex-shrink-0"></div>
              {/* {data} */}
              <Markdown
                typing={false}
                text={data}
                className="!text-14px !leading-28px pr-16px flex-grow overflow-y-auto scrollbar"
                ref={refTextScroll}
                components={{
                  img: ({ node, className, children, src, alt, ...props }) => {
                    return src;
                  },
                }}
              />
            </div>
          )
        }
      </div>
    </>
  );
});

export default CardThinking;
